import Component from '../colorz/Component';

export default class CustomerPreference extends Component {
	onInit(el) {
		this.el = el;
		this.route = 'apps/clrz/klaviyo/update-optin';
		this.body = {};
		this.elForm = this.el.closest('form');
	}

	onReady() {
		this.el.addEventListener('change', this.onSubmit.bind(this));
	}

	/**
	 * onSubmit
	 * everytime an input is change
	 */
	async onSubmit(event) {
		event.preventDefault();
		this.clearMessage();

		switch (event.target.id) {
			case 'customers-newsletter':
				this.body['subscribe_email'] = event.target.checked;
				this.body['subscribe_sms'] = null;
				break;
			case 'customers-sms':
				this.body['subscribe_sms'] = event.target.checked;
				this.body['subscribe_email'] = null;
				break;
		}

		await this.updateInfos()
			.then((res) => {
				return res.json();
			})
			.then((data) => {
				console.log('data', data);
				if (data.success !== true) {
					this.onError(data.message);
				} else {
					this.onSuccess();
				}
			})
			.catch((error) => {
				console.error(error);
				this.onError();
			})
			.finally(() => {});
	}

	updateInfos() {
		return fetch(`${window.location.origin}/${this.route}`, {
			method: 'POST',
			body: JSON.stringify(this.body),
		});
	}

	enableLoading() {
		this.el.setAttribute(PersonalInfos.attrs.loading, true);
		document.activeElement.blur();
		this.elFormStatus.setAttribute('aria-hidden', false);
	}

	disableLoading() {
		this.el.removeAttribute(PersonalInfos.attrs.loading);
		this.elFormStatus.setAttribute('aria-hidden', 'true');
	}

	onSuccess() {
		this.elMsgSuccess = document.createElement('p');
		this.elMsgSuccess.classList.add('u-text-blue', 'customer-msg-status');
		this.elMsgSuccess.innerText = this.el.dataset.stringSuccess || 'Success';
		this.elForm.append(this.elMsgSuccess);
	}

	onError(msg = '') {
		this.elMsgError = document.createElement('p');
		this.elMsgError.classList.add('u-text-maroon', 'customer-msg-status');
		this.elMsgError.innerText = this.el.dataset.stringError || msg || 'Error';
		this.elForm.append(this.elMsgError);
	}

	clearMessage() {
		const messages = this.elForm.querySelectorAll('.customer-msg-status');
		for (let message of messages) {
			message.remove();
		}
	}
}
